'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++)arr2[i]=arr[i];return arr2}else{return Array.from(arr)}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const BaseDataService=require('../../../dist-es6/client/services/baseDataService');
const GroupTreeService=require('../../../dist-es6/client/services/groupTreeService');
const treeUtils=require('pulsar-utils/dist-es6/treeUtils');let

GroupBasedDataService=function(_BaseDataService){_inherits(GroupBasedDataService,_BaseDataService);_createClass(GroupBasedDataService,null,[{key:'$inject',get:function()
{
return['$timeout','groupTreeService'];
}}]);

function GroupBasedDataService($timeout,groupTreeService){_classCallCheck(this,GroupBasedDataService);
_.ensureInstanceOf(GroupTreeService,groupTreeService);var _this=_possibleConstructorReturn(this,

_BaseDataService.call(this,$timeout));

_this._groupTreeService=groupTreeService;

_this._clearCache();
_this._clearPersistentData();return _this;
}GroupBasedDataService.prototype.

_clearCache=function _clearCache(){
this._groupTree=null;
this._groupsById=null;
};GroupBasedDataService.prototype.

_clearPersistentData=function _clearPersistentData(){
this._selectedGroupData=null;
};GroupBasedDataService.prototype.

selectGroupDataFor=function selectGroupDataFor(groupId){
if(!_.exists(this._groupsById)){
this._selectedGroupData=null;
return;
}
this._selectedGroupData=this._groupsById[groupId]||null;
};_createClass(GroupBasedDataService,[{key:'selectedGroupData',get:function()

{

return this._selectedGroupData;
}},{key:'fatigueMeterType',get:function()

{
return this._fatigueMeterType;
},set:function(

fatigueMeterType){
this._fatigueMeterType=fatigueMeterType;
}},{key:'groupTree',get:function()

{
return this._groupTree;
},set:function(

groupTree){
this._groupTreeService.groupTree=groupTree;
this._groupTree=groupTree;
this._groupsById=_([].concat(_toConsumableArray(treeUtils.flatten(groupTree)))).keyBy(function(group){return group.id}).value();
this.selectGroupDataFor(this._groupTreeService.selectedGroup.id);
}}]);return GroupBasedDataService}(BaseDataService);


module.exports=GroupBasedDataService;
//# sourceMappingURL=groupBasedDataService.js.map
